// Debug logging is off in production; set localStorage.ssFiltersDebug = '1'
// in the console to re-enable it.
function ssSortDebugLog() {
  try {
    if (window.localStorage && localStorage.getItem('ssFiltersDebug')) {
      console.log.apply(console, arguments);
    }
  } catch (e) { /* storage unavailable */ }
}
/**
 * ============================================================================
 * SEARCHSPRING SORT INTEGRATION
 * ============================================================================
 * 
 * Finds SearchSpring's sort select element and moves it to the unified
 * filter bar on the far right.
 * 
 * SearchSpring renders the sort select asynchronously, so we need to
 * watch for it and move it when it appears.
 * ============================================================================
 */

(function() {
  'use strict';

  const CONFIG = {
    sortSelectId: 'ss__sort--select',
    sortSelectName: 'ss__sort--select',
    sortWrapperSelector: '.searchspring-unified-filter-bar__sort'
  };

  function findAndMoveSortSelect() {
    const sortWrapper = document.querySelector(CONFIG.sortWrapperSelector);
    if (!sortWrapper) {
      ssSortDebugLog('[SS Sort] Sort wrapper not found');
      return false;
    }

    // Check if wrapper already has a container but missing the select (SearchSpring replaced it)
    const existingContainer = sortWrapper.querySelector('.searchspring-sort-wrapper');
    if (existingContainer) {
      const existingSelect = existingContainer.querySelector('select');
      if (!existingSelect) {
        // Container exists but select is missing - SearchSpring replaced it
        ssSortDebugLog('[SS Sort] Select was replaced, looking for new one...');
        // Don't remove container yet, we'll add the new select to it
      } else {
        // Container and select both exist - check if select is in the right place
        if (sortWrapper.contains(existingSelect)) {
          return true; // Already properly set up
        }
      }
    }

    // Try to find by ID first
    let sortSelect = document.getElementById(CONFIG.sortSelectId);
    
    // Fallback: try to find by name attribute
    if (!sortSelect) {
      sortSelect = document.querySelector(`select[name="${CONFIG.sortSelectName}"]`);
    }
    
    // Fallback: try to find any select with ss__ in the name/id
    if (!sortSelect) {
      sortSelect = document.querySelector('select[id*="ss__sort"], select[name*="ss__sort"]');
    }

    if (sortSelect && sortWrapper) {
      // Check if already in our wrapper
      if (sortWrapper.contains(sortSelect)) {
        return true; // Already in place
      }

      // If container exists but select is missing, reuse the container
      let sortContainer = existingContainer;
      if (!sortContainer) {
        // Create new container
        sortContainer = document.createElement('div');
        sortContainer.className = 'searchspring-sort-wrapper';
        sortContainer.style.display = 'flex';
        sortContainer.style.alignItems = 'center';
        sortContainer.style.gap = '8px';
        
        // Add arrow icon (same as featured filters) - only if creating new container
        const arrow = document.createElement('span');
        arrow.className = 'searchspring-sort-arrow';
        arrow.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.99948 8.78092L11.2993 5.48111L12.2421 6.42392L7.99948 10.6666L3.75684 6.42392L4.69965 5.48111L7.99948 8.78092Z" fill="#4A4E54"/></svg>';
        arrow.style.display = 'inline-flex';
        arrow.style.alignItems = 'center';
        arrow.style.flexShrink = '0';
        sortContainer.appendChild(arrow);
      }
      
      // Move the select into the container (before the arrow)
      sortContainer.insertBefore(sortSelect, sortContainer.firstChild);
      
      // Move the container to the wrapper (if not already there)
      if (!sortWrapper.contains(sortContainer)) {
        sortWrapper.appendChild(sortContainer);
      }
      
      ssSortDebugLog('[SS Sort] Sort select moved to unified bar with arrow');
      return true;
    }

    return false;
  }

  // Keep observer running to catch SearchSpring replacing the select
  let sortObserver = null;

  function initSortIntegration() {
    // Try immediately
    findAndMoveSortSelect();

    // Watch for SearchSpring to render or replace the sort select
    // Keep observer running (don't disconnect) so we catch replacements
    if (!sortObserver) {
      sortObserver = new MutationObserver(() => {
        findAndMoveSortSelect();
      });

      // Observe SearchSpring's own container when present (it re-renders
      // there); the body fallback only applies before SS has painted once.
      const observeTarget = document.getElementById('searchspring-content') || document.body;
      sortObserver.observe(observeTarget, {
        childList: true,
        subtree: true,
        attributes: false
      });
    }

    // Also watch specifically the sort wrapper for when select is removed
    const sortWrapper = document.querySelector(CONFIG.sortWrapperSelector);
    if (sortWrapper && !sortWrapper.hasAttribute('data-observed')) {
      sortWrapper.setAttribute('data-observed', 'true');
      const wrapperObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          // If select was removed from our container, look for new one
          if (mutation.type === 'childList' && mutation.removedNodes.length > 0) {
            const removedSelect = Array.from(mutation.removedNodes).find(
              node => node.nodeName === 'SELECT'
            );
            if (removedSelect) {
              ssSortDebugLog('[SS Sort] Select was removed, watching for replacement...');
              // Check again after a brief delay
              setTimeout(findAndMoveSortSelect, 100);
            }
          }
        });
      });
      
      wrapperObserver.observe(sortWrapper, {
        childList: true,
        subtree: true
      });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSortIntegration);
  } else {
    initSortIntegration();
  }

  // Retry after delay in case SearchSpring loads late
  setTimeout(initSortIntegration, 2000);

  // ------------------------------------------------------------------------
  // Hide SearchSpring product count/toolbar
  // This allows collection-filter to have line-height: 0
  // ------------------------------------------------------------------------
  function hideSearchSpringProductCount() {
    // Find SearchSpring toolbar with product count
    const toolbar = document.querySelector('.ss__toolbar, [class*="ss__toolbar"], [class*="ss-toolbar"]');
    if (toolbar) {
      toolbar.style.display = 'none';
      toolbar.style.lineHeight = '0';
      ssSortDebugLog('[SS Sort] Hidden SearchSpring toolbar/product count');
    }
    
    // Also look for product count specifically
    const productCount = document.querySelector('[class*="ss__"][class*="count"], [class*="ss-"][class*="count"]');
    if (productCount) {
      productCount.style.display = 'none';
      productCount.style.lineHeight = '0';
    }
    
    // Look for any element with "X products" text that might be the count.
    // Scoped to SearchSpring's own container and anchored to the exact
    // "N products" form — the old unanchored /products?$/ arm hid any
    // ss-* element whose text merely ended in "product(s)".
    const scope = document.getElementById('searchspring-content') || document;
    const allElements = scope.querySelectorAll('[class*="ss__"], [class*="ss-"]');
    allElements.forEach(el => {
      const text = (el.textContent || '').trim();
      if (text.match(/^\d+\s+products?$/i)) {
        el.style.display = 'none';
        el.style.lineHeight = '0';
      }
    });
  }

  // Hide product count when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideSearchSpringProductCount);
  } else {
    hideSearchSpringProductCount();
  }

  // Watch for SearchSpring to render toolbar and hide it — scoped to its
  // container and throttled (mutation bursts on every facet render).
  let toolbarHideQueued = false;
  const toolbarObserver = new MutationObserver(() => {
    if (toolbarHideQueued) return;
    toolbarHideQueued = true;
    setTimeout(() => {
      toolbarHideQueued = false;
      hideSearchSpringProductCount();
    }, 100);
  });

  toolbarObserver.observe(document.getElementById('searchspring-content') || document.body, {
    childList: true,
    subtree: true
  });

  // Retry hiding after delay
  setTimeout(hideSearchSpringProductCount, 2000);
  setTimeout(hideSearchSpringProductCount, 5000);

})();
